@if (!loading) {
  <div class="app-container">
    @if (headerItems && !isFullPageRoute()) {
      <lib-header [adminUrl]="adminUrl" [headerItems]="headerItems" [isProvider]="isProvider" [showHeaderButtons]="!isWizardRoute()" (entraLogout)="logout()"></lib-header>
    }
    @if (!isFullPageRoute() && !isWizardRoute()) {
      <lib-subheader [topMenu]="menu"></lib-subheader>
      <app-banner [configs]="bannerConfig" (dismissBanner)="dismissBanner($event)"></app-banner>
    }
    <div class="body">
      <main>
        <router-outlet />
      </main>
    </div>
    <lib-footer></lib-footer>
  </div>
}
